import { Download, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/v2/button";
import useToast from "@/lib/hooks/useToast";

type InvoiceDownloadButtonProps = {
  onDownload: () => void;
  isLoading?: boolean;
  hasData?: boolean;
};

export function InvoiceDownloadButton({
  onDownload,
  isLoading = false,
  hasData = false,
}: InvoiceDownloadButtonProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();

  const handleClick = () => {
    showToast(t("common.downloading"), "info");
    onDownload();
  };

  return (
    <Button onClick={handleClick} variant="ghost" disabled={isLoading || !hasData}>
      {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download />}
      {t("common.download")}
    </Button>
  );
}
